/**
 * 배너 유틸리티 함수들
 * 원본: center-title.html의 BannerRenderer 전역 객체
 */

import React from 'react';
import { Link } from 'react-router-dom';

/**
 * breadcrumbPath를 기반으로 "HOME > 대분류 > 중분류 > 소분류" 형식의 메뉴 경로를 생성합니다.
 * HOME은 링크로 렌더링됩니다.
 * @param {Array|string|null} breadcrumbPath - breadcrumb 경로 배열, 각 항목은 {label, href} 형태, 또는 문자열
 * @returns {React.ReactElement|string} - JSX 요소 또는 문자열
 */
export function getMenuPath(breadcrumbPath) {
  // null, undefined, 빈 값 처리
  if (!breadcrumbPath) {
    return (
      <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
        HOME
      </Link>
    );
  }

  // 문자열인 경우 (잘못된 형식이 전달된 경우)
  if (typeof breadcrumbPath === 'string') {
    // 빈 문자열이면 HOME만 반환
    if (breadcrumbPath.trim() === '') {
      return (
        <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
          HOME
        </Link>
      );
    }
    // 문자열이면 "HOME > 문자열" 형식으로 반환
    return (
      <>
        <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
          HOME
        </Link>
        {' > '}
        {breadcrumbPath}
      </>
    );
  }

  // 배열이 아닌 경우
  if (!Array.isArray(breadcrumbPath)) {
    return (
      <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
        HOME
      </Link>
    );
  }

  // 빈 배열인 경우
  if (breadcrumbPath.length === 0) {
    return (
      <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
        HOME
      </Link>
    );
  }

  // JSX 요소 배열 생성
  const elements = [
    <Link key="home" to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
      HOME
    </Link>
  ];

  // breadcrumbPath의 각 항목에서 label 추출
  breadcrumbPath.forEach((item, index) => {
    if (item && item.label) {
      elements.push(' > ');
      const href = item.href;
      elements.push(
        href ? (
          <Link key={`item-${index}`} to={href} style={{ color: 'inherit', textDecoration: 'none' }}>
            {item.label}
          </Link>
        ) : (
          <span key={`item-${index}`}>{item.label}</span>
        )
      );
    }
  });

  return <>{elements}</>;
}

/**
 * XSS 방지를 위한 HTML 이스케이프 함수
 * @param {string} text - 이스케이프할 텍스트
 * @returns {string} - 이스케이프된 텍스트
 */
export function escapeHtml(text) {
  if (!text) return '';
  const map = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return String(text).replace(/[<>"']/g, (m) => map[m]);
}

